<template>
    <div class="mod mod-half mod-fbl">
        <h2><i>7</i>涨跌统计<span class="icon-help" v-on:click="toggle">?</span></h2>
        <div class="chart-legend">
            <span class="red">涨停<b>{{legend.zt}}家</b></span>
            <span class="red">上涨<b>{{legend.sz}}家</b></span>
            <span class="green">下跌<b>{{legend.xd}}家</b></span>
            <span class="green">跌停<b>{{legend.dt}}家</b></span>
        </div>
        <div class="chart-wrap" id="zdtj-echart-container"><p class="blank">-- 暂无数据 --</p></div>
        <p class="help-pop" style="display: block" v-show="isHelp">涨幅大于5%的个股数量对判断沪深A股当日人气有重要作用，涨幅超过5%的个股数量越多，市场人气越高；反之，则说明市场人气低迷，大盘上涨压力大。</p>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    export default {
        data () {
            return {
                isHelp:false,
                legend:{ dt:"--", xd:"--", sz:"--", zt:"--"},
                chartData:[],
                jrqsgn:[]
            }
        },
        computed: {
            ...mapState(['isBlankPage'])
            //this.BlankPage;
        },
        mounted:function(){
            this.getMarkettrendMinInfo();
            this.getStkdataInfo();
        },
        methods: {
            getMarkettrendMinInfo:function () {
                var _this = this;
                dzhyun.query('/markettrend/index/min', { obj:'SH000001,SZ399001',start:'-1' }, function(data) {
                    //...
                }).then(function(data) {
                    _this.handleGetMarkettrendMinSucc(data);
                }).catch(function(err) {
                    //...
                });
            },
            handleGetMarkettrendMinSucc:function(res) {
                if(res.length>0){
                    this.legend.dt = res[0].Data[0].DieTingJiaShu     + res[1].Data[0].DieTingJiaShu;
                    this.legend.xd = res[0].Data[0].XiaDieJiaShu      + res[1].Data[0].XiaDieJiaShu;
                    this.legend.sz = res[0].Data[0].ShangZhangJiaShu  + res[1].Data[0].ShangZhangJiaShu;
                    this.legend.zt = res[0].Data[0].ZhangTingJiaShu   + res[1].Data[0].ZhangTingJiaShu;
                    this.chartData.push(
                        res[0].Data[0].DieTingJiaShu   + res[1].Data[0].DieTingJiaShu,
                        res[0].Data[0].DieFuDaYu5      + res[1].Data[0].DieFuDaYu5,
                        res[0].Data[0].DieFuDaYu2      + res[1].Data[0].DieFuDaYu2,
                        res[0].Data[0].DieFuDaYu0      + res[1].Data[0].DieFuDaYu0,
                        res[0].Data[0].ZhangFuDaYu0    + res[1].Data[0].ZhangFuDaYu0,
                        res[0].Data[0].ZhangFuDaYu2    + res[1].Data[0].ZhangFuDaYu2,
                        res[0].Data[0].ZhangFuDaYu5    + res[1].Data[0].ZhangFuDaYu5,
                        res[0].Data[0].ZhangTingJiaShu + res[1].Data[0].ZhangTingJiaShu
                    );
                }
                if(!this.isBlankPage && this.chartData.length>0){
                    this.myChart();
                }
            },
            getStkdataInfo:function () {
                var _this = this;
                dzhyun.query('/stkdata', { gql: 'block=股票/大智慧自定义/板块综合',field:'ZhongWenJianCheng',orderby:'ZhangFu',desc:'true',count:'2' }, function(data) {
                    //...
                }).then(function(data) {
                    _this.handleGetStkdataSucc(data);
                }).catch(function(err) {
                    //...
                });
            },
            handleGetStkdataSucc:function(res) {
                if(res.length>0){
                    for(var i=0;i<res.length;i++){
                        if(res[i].ZhongWenJianCheng == "" ||  res[i].ZhongWenJianCheng == null || res[i].ZhongWenJianCheng == undefined){
                            res[i].ZhongWenJianCheng="--";
                        }
                        if(res[i].ZhangFu == "" || res[i].ZhangFu == null || res[i].ZhangFu == undefined){
                            res[i].ZhangFu = "--";
                        }
                    }
                    this.jrqsgn=res;
                }
            },
            myChart:function() {
                let echart = echarts.init(document.getElementById('zdtj-echart-container'),'white');
                let option  = {
                    backgroundColor: '#FFFFFF',
                    title: {
                        show: true,
                        //text: '沪深涨跌停走势',
                        textStyle: {
                            color: '#222',
                            fontSize: 12,
                            fontWeight: 'normal'
                        },
                        z: 2,
                        left: 30,
                        top: '5px'
                    },
                    tooltip: {
                        trigger: 'axis',
                        backgroundColor: '#406cc2',
                        textStyle: {
                            color: "#fff",
                            fontSize: 12
                        },
                        position: function (point) {
                            // 固定在顶部
                            // return [point[0], '0'];
                        },
                        padding: [5, 10],
                        confine: true,
                        formatter: function (params) {
                            var string = '';
                            if (!isNaN(params[0].value)) {
                                string += params[0].value + '家<br/>';
                            }
                            return (string == '') ? false : params[0].name + ':' + string;
                        },
                        axisPointer: {
                            lineStyle: {color: '#406cc2'},
                        }
                    },
                    color: ['#fd8824','#FF0000', '#009936'],
                    grid: {
                        left: 10,
                        right: 30,
                        top: 20,
                        bottom: 0,
                        containLabel: true
                    },
                    dataZoom: [{
                        type: 'slider',
                        show: false
                    }],
                    xAxis: {
                        type: 'category',
                        axisLabel: {
                            interval: 0,
                            rotate:30,
                            textStyle: {fontSize: 10},
                        },
                        axisTick:{
                            show:false //是否显示坐标轴刻度
                        },
                        data:["跌停","跌停~-5%","-5%0~-2%","-2%~0","0~2%","2%~5%","5%~涨停","涨停"]
                    },
                    yAxis: {
                        type: 'value',
                        scale: true,
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            margin: 2,
                            textStyle: {fontSize: 13}
                        },
                        splitLine: {
                            show: true,
                        },
                        splitNumber: 3,
                    },
                    series: [
                        {
                            type:'bar',
                            barWidth:20,
                            itemStyle:{
                                normal:{
                                    color: function(params) {
                                        var colorList = ['#13a977','#13a977','#13a977','#13a977','#C33531', '#C33531','#C33531','#C33531' ];
                                        return colorList[params.dataIndex]
                                    },
                                    label : {show: true, position: 'top'}
                                }},
                            data:[]
                        }
                    ]
                };
                echart.setOption(option);
                echart.setOption({series: [{data: this.chartData}]});
            },
            // 持仓温度帮助弹窗
            toggle: function () {
                this.isHelp =! this.isHelp;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/home/components/zdtj.vue